import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { getUser } from "../../utils/localStorage";
import { UNIVERSAL_SEARCH_URL } from "../../utils/constants";

//import ServiceDetailsTable from "../../components/ServiceRequests/ThreeSixtyDegreeView/ServiceDetailsTable";
import ServicessDetailsTable from "../../components/ServiceRequests/ThreeSixtyDegreeView/ServicessDetailsTable";
//import UserDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserDetails";
import UserssDetails from "../../components/ServiceRequests/ThreeSixtyDegreeView/UserssDetails";
import { Button } from "../../common/Button/Button";
//import LpmThreeSixtyGrid from "../../components/ServiceRequests/Facilitator/LpmThreeSixtyGrid";

export default function ServicessDetailsContainer(props) {
	const calculateDisableMe = (services) => {
		if (services === undefined) return;
		let flag = true;
		for (let i = 0; i < services.length; i++) {
			if (services[i]["existing_service_facilitator"]) {
				// console.log('check  services[i]["existing_service_facilitator"]["is_active"]',services[i]["existing_service_facilitator"]["is_active"]);
				// console.log('check  services[i]["existing_service_facilitator"]["out_of_office"]',services[i]["existing_service_facilitator"]["out_of_office"])
				if (
					services[i]["existing_service_facilitator"]["is_active"] ===
						true &&
					services[i]["existing_service_facilitator"][
						"out_of_office"
					] === false
				) {
					flag = false;
				}
				// console.log('checkemail::::',services[i]["existing_service_facilitator"]["email"])
				if (
				services[i]["existing_service_facilitator"]["email"] ===
						getUser().email
				)
				{
					flag = true;
				}
			}
		}

		return flag;
	};
	const renderTabs = () => {
		const {
			userDataWP,
			servicesLPMByUserId,
			servicesSPMSectionAByUserId,
			servicesSPMSectionBByUserId,
			servicesLSSortedByUserId,
		} = props;
		if (
			servicesLPMByUserId.length ||
			servicesSPMSectionAByUserId.length ||
			servicesSPMSectionBByUserId.length 
			// servicesLSSortedByUserId.length === 0
		)
			return;

		const tabHeaders = props.totalUsers.map((e, index) => {
			return <Tab>{e}</Tab>;
		});
		const tabs = props.totalUsers.map((e, index) => {
			return (
				<>
				
					<TabPanel>
						<div
							// style={{
							// 	// display: "flex",
							// 	// flexDirection: "column",
							// 	// alignItems: "center",
							// 	justifyContent: "center",
							// }}
						>
							<div style={{ width: "",marginRight:"13%",marginLeft:"2%",marginTop: "50px", }}>
							 
								<UserssDetails
									data={props.userDataWP[e] ?? []}
									userData={props.userData}
									toggleViewAllNotesModal={props.toggleViewAllNotesModal}
									toggleViewAllSMSModal={props.toggleViewAllSMSModal}
									toggleUserProfileModal={props.toggleUserProfileModal}
									nUserId={e}
								></UserssDetails>
								 

								 {props.userDataWP[e]?
									(
										""
									):
									(
										<Button 
								onClick={()=>{props.toggleViewAllNotesModal(e)}}
								style={{float:"left",marginLeft:"10px"}}
								>
								View All Notes
								</Button>
									)
								}

								<br></br><br></br>
								{props.userDataWP[e]?
									(
										""
									):
									(
								<Button 
								onClick={()=>{props.toggleViewAllSMSModal(e)}}
								style={{float:"left",marginLeft:"10px",width:"118px"}}
								>
								View All SMS
								</Button>
									)
								}
 
							 
								 

							</div>
							<br></br><br></br>
							 
							<div
								style={{
                                    
									width: "",
									marginBottom: "20px",
									marginTop: "25px",
									marginLeft:"2%",
									marginRight:"2%"
									
								}}
							>
								<span style={{marginLeft:"1%",marginBottom:"0%",fontWeight:"bold"}}>Services In LPM</span>
								<ServicessDetailsTable
									data={props.servicesLPMByUserId[e]}
									assignToMeClick={props.assignToMeClick}
									disableAssignToMe={calculateDisableMe(
										props.servicesLPMByUserId[e]
									)}
									toggleLPMNotesModal={props.toggleLPMNotesModal}
									nUserId={e}
									isLoading={props.isLoadingServicesLPM}  
									mainLoader={props.mainLoader}
									
									//label ={"Services In LPM"}
								></ServicessDetailsTable>
							</div>

							<div style={{ width: "",marginBottom: "10px",marginTop: "25px",marginLeft:"2%",marginRight:"2%"}}>
							<span style={{marginLeft:"1%",marginBottom:"1%",fontWeight:"bold"}}>Services In SPM</span>
								<ServicessDetailsTable
									data={props.servicesSPMSectionAByUserId[e]}
									SPMServices={true}
									toggleNotesModal={props.toggleNotesModal}
									section={"A"}
									isLoading={props.isLoadingServicesSPM}  
									mainLoader={props.mainLoader}
									// label={
									// 	"Services In SPM"
									// }
								></ServicessDetailsTable>
							</div>
							{/* <div style={{ width: "",marginBottom: "5px",marginTop: "25px",marginLeft:"2%",marginRight:"2%"}}>
							<span style={{marginLeft:"1%",marginBottom:"0%",fontWeight:"bold"}}>Service from SPM</span>
								<ServicessDetailsTable
									data={props.servicesSPMSectionBByUserId[e]}
									SPMServices={true}
									toggleNotesModal={props.toggleNotesModal}
									section={"B"}
									// label={
									// 	"Service from SPM"
									// }
								></ServicessDetailsTable>
							</div> */}
							<div
								style={{
									width: "",
									marginBottom: "10px",
									marginTop: "25px",
									marginLeft:"0%",
									marginRight:"4%",		
								}}
							>
								<span style={{marginLeft:"3%",marginBottom:"0%",fontWeight:"bold"}}>Lead Details from LS</span>
								<ServicessDetailsTable
									data={props.servicesLSSortedByUserId[e]}
									nUserId={e}
									LSServices={true}
									//label={"Lead Details from LS"}
								></ServicessDetailsTable>
							</div>
						</div>

					</TabPanel>
				</>
			);
		});
		
		let tabHeaderContainer = (
			<>
				<Tabs>
					{/* <span>Showing Results For:{tabHeaders}</span> */}
					<TabList className="tabs-container">{tabHeaders}</TabList>
					{tabs}
				</Tabs>
			</>
		);
		return tabHeaderContainer;
	};

	return <>{renderTabs()} </>;
}
